import styled from 'styled-components';
import { Palette } from 'core/config';
import { makeStyles } from '@material-ui/core/styles';

export const useStepperStyles = makeStyles({
    root: {
        position: 'relative !important' as any,
        transform: 'translateY(100px) !important',
        background: `${Palette.EGGSHELL_WHITE} !important`,
        justifyContent: 'center !important'
    },
    progress: {
        backgroundColor: `${Palette.TAN} !important`,
        borderRadius: '10px !important',
        height: '7px !important'
    },
    bar: {
        backgroundColor: `${Palette.ORANGE} !important`
    }
});

export const Container = styled.div<{ isLoading: boolean; }>`
    opacity: ${({ isLoading }) => isLoading ? 0 : 1};
    transition: all 300ms ease 0.5s, visibility 0s linear 0s;
`;
export const FakeButton = styled.button`
    display: none;
`;
